import { render, staticRenderFns } from "./messageHint.vue?vue&type=template&id=bc905f2e&scoped=true"
import script from "./messageHint.vue?vue&type=script&lang=js"
export * from "./messageHint.vue?vue&type=script&lang=js"
import style0 from "./messageHint.vue?vue&type=style&index=0&id=bc905f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc905f2e",
  null
  
)

export default component.exports